import {
  findKey
} from "lodash"
import {
  isClient
} from "common/helper"
import {
  cleanEnv,
  str
} from "envalid"

// console.log("process.env", process.env)

export const envConfig = cleanEnv(process.env, {
  REACT_APP_ENV: str(),
  REACT_APP_VERSION: str(),
  REACT_APP_DEFAULT_LANG: str(),
  NODE_ENV: str(),
})

const config = {
  production: {
    HOST: "https://flex.axa.zennite.co",
    API_ENDPOINT: "https://flex-api.axa.zennite.co/graphql",
    API: "https://flex-api.axa.zennite.co",
  },
  uat: {
    HOST: "https://flex.axa-uat.zennite.co",
    API_ENDPOINT: "https://flex-api.axa-uat.zennite.co/graphql",
    API: "https://flex-api.axa-uat.zennite.co",
  },
  staging: {
    HOST: "https://flex.axa-uat.zennite.co",
    API_ENDPOINT: "https://flex-api.axa-uat.zennite.co/graphql",
    API: "https://flex-api.axa-uat.zennite.co",
  },
  development: {
    HOST: "http://localhost:21703",
    API_ENDPOINT: "http://localhost:22901/graphql",
    API: "http://localhost:22901",
  },
  development2: {
    HOST: "http://localhost:21703",
    API_ENDPOINT: "http://localhost:22901/graphql",
    API: "http://localhost:22901",
  },
}

export const getEnvByHost = () => (isClient ? findKey(config, {
  HOST: window.location.origin
}) : null)

export const env = getEnvByHost() || "production"

console.log("ENV : ", getEnvByHost())
console.log("HOST : ", window.location.origin)
console.log("GET HOST : ", config[env].HOST)

const backofficeEnvConfig = {
  production: {
    HOST: "https://flex.backoffice.axa.zennite.co",
    API_ENDPOINT: "https://flex-api.axa.zennite.co/graphql",
    API: "https://flex-api.axa.zennite.com",
  },
  uat: {
    HOST: "https://flex.backoffice.axa-uat.zennite.co",
    API_ENDPOINT: "https://flex-api.axa-uat.zennite.co/graphql",
    API: "https://flex-api.axa-uat.zennite.co",
  },
  staging: {
    HOST: "https://flex.backoffice.axa-uat.zennite.co",
    API_ENDPOINT: "https://flex-api.axa-uat.zennite.co/graphql",
    API: "https://flex-api.axa-uat.zennite.co",
  },
  development: {
    HOST: "http://localhost:21702",
    API_ENDPOINT: "http://localhost:22901/graphql",
    API: "http://localhost:22901",
  },
  development2: {
    HOST: "http://localhost:21702",
    API_ENDPOINT: "http://localhost:22901/graphql",
    API: "http://localhost:22901",
  },
}

export const backofficeEnv = backofficeEnvConfig[env]

export default config[env]